// @flow
import React, { useRef } from "react";
import { css } from "styled-components";
import { useSelector } from "react-redux";
import { media } from "@nested/rebrand";
import { SlickStyles } from "@nested/ui";
import { Button, ButtonLink } from "@nested/component-library";
import { fetchForSaleProperties } from "../ForSaleList/ducks";
import { Carousel } from "./Carousel";
import {
  regularHeading,
  sectionHeading,
  largeHeading,
} from "../../components/Typography/Headings";

import { LeftArrow, RightArrow } from "../../icons";

const backgroundStyle = css`
  padding: 40px 0px;
  background-color: white;
  ${media.desktop`
    padding: 80px 0;
  `}
`;

const wrapperStyle = css`
  text-align: center;
`;

const headerStyles = css`
  padding: 0px 20px;
`;

const heading6Style = css`
  ${sectionHeading}
  margin: 0 auto;
`;

const heading3Style = css`
  ${regularHeading}
  margin: 0 auto 30px auto;
  white-space: pre-wrap;
  ${media.tablet`
    ${largeHeading}
    margin: 0 auto 40px auto;
  `}
  ${media.desktop`
    margin: 10px auto 60px auto;
  `}
`;

const buttonWrapperStyle = css`
  display: inline-flex;
  margin-top: 30px;
  ${media.tablet`
    margin-top: 40px;
  `}
  ${media.desktop`
    margin-top: 60px;
  `}
`;

const buttonLinkStyle = css`
  margin: 0px 10px;
  ${media.tablet`
    margin: 0px 20px;
  `}
`;

const arrowStyle = css`
  width: 24px;
  display: block;
  ${media.tablet`
    width: 38px;
 `}
`;

type Props = {
  buttonLabel: string,
  heading: string,
  outcodesToInclude?: string[],
  localLandingPageCarousel?: boolean,
};

const PropertyCarousel = ({ buttonLabel, heading }: Props) => {
  const slider = useRef();
  const properties = useSelector(
    (state) => state.forSalePage.forSaleProperties || [],
  );

  return (
    <>
      <div css={backgroundStyle}>
        <SlickStyles />
        <div css={wrapperStyle}>
          <div css={headerStyles}>
            <h6 css={heading6Style}>For Sale</h6>
            <h3 css={heading3Style}>{heading}</h3>
          </div>

          <Carousel propertyList={properties} sliderRef={slider} />
          <div css={buttonWrapperStyle}>
            <Button
              noText
              onClick={() => {
                // $FlowFixMe
                slider.current.slickPrev();
              }}
            >
              <LeftArrow css={arrowStyle} />
            </Button>
            <ButtonLink css={buttonLinkStyle} to="/for-sale">
              {buttonLabel}
            </ButtonLink>
            <Button
              noText
              onClick={() => {
                // $FlowFixMe
                slider.current.slickNext();
              }}
            >
              <RightArrow css={arrowStyle} />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

PropertyCarousel.fetchData = fetchForSaleProperties;

export { PropertyCarousel };
